// src/components/Navbar.js

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { FaCog, FaSignOutAlt, FaCommentDots, FaSun, FaMoon } from 'react-icons/fa';
import { renderGeometricAvatar } from '../../utils/avatar';
import './Navbar.css'; 

export const Navbar = ({ user, onLogout, onOpenChat, onOpenSettings, storageUsed }) => {
  const { theme, toggleTheme } = useTheme();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  const displayName = user.user_metadata?.display_name || user.email;

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="navbar-brand-link">
          <h1>MyDrive</h1>
        </Link>
      </div>
      
      <div className="navbar-menu"></div>

      <div className="navbar-user">
        <button className="navbar-theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
          {theme === 'light' ? <FaMoon /> : <FaSun />}
        </button>

        <button className="navbar-chat-button" onClick={() => onOpenChat()}>
          <FaCommentDots />
          <span>AI Chat</span>
        </button>

        <div className="user-dropdown-container" ref={dropdownRef}>
          <div className="user-dropdown-trigger" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              {renderGeometricAvatar(user.user_metadata?.avatar_template || 0, 38, '-navbar')}
              <span>{displayName}</span>
          </div>
          <div className={`user-dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <button 
                className="dropdown-item" 
                onClick={() => {
                  setIsDropdownOpen(false);
                  onOpenSettings();
                }}
              >
                  <FaCog /> Settings
              </button>
              <div className="dropdown-divider"></div>
              <button onClick={onLogout} className="dropdown-item dropdown-item-logout">
                  <FaSignOutAlt /> Logout
              </button>
          </div>
        </div>
      </div>
    </nav>
  );
};